export default "__VITE_ASSET__CyZCHWmB__"